import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-Check-24",
  "use": "ico-Check-24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-Check-24\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.2071 7.29289C18.5976 7.68342 18.5976 8.31658 18.2071 8.70711L10.2071 16.7071C9.81658 17.0976 9.18342 17.0976 8.79289 16.7071L5.79289 13.7071C5.40237 13.3166 5.40237 12.6834 5.79289 12.2929C6.18342 11.9024 6.81658 11.9024 7.20711 12.2929L9.5 14.5858L16.7929 7.29289C17.1834 6.90237 17.8166 6.90237 18.2071 7.29289Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol